<ng-container *ngIf="project$ | async; let project">
  <div class="breadcrumbs">
    <span class="breadcrumb-element" [title]="project.client.client_code">{{
      project.client.client_code
    }}</span>
    <span class="breadcrumb-divider">/</span>
    <a
      class="breadcrumb-element"
      [href]="buildProjectGroupPath(project)"
      [title]="projectGroupLabel$ | async"
      (click)="$event.stopPropagation()"
      >{{ projectGroupLabel$ | async }}
    </a>
    <span class="breadcrumb-divider">/</span>
    <a
      class="breadcrumb-element"
      [href]="buildProjectPath(project)"
      [title]="project.name"
      (click)="$event.stopPropagation()"
      >{{ project.name }}</a
    >
    <ng-container *ngIf="step$ | async as step">
      <span class="breadcrumb-divider">/</span>
      <span class="breadcrumb-element step-crumb" [title]="step">{{
        step
      }}</span>
    </ng-container>
  </div>
  <div class="breadcrumbs">
    <span
      >{{ project.project_type
      }}{{ project.state === 'paused' ? ' (paused)' : '' }}</span
    >
    <ng-content></ng-content>
  </div>
</ng-container>
